import React from "react";
import { instagramHandle } from "../lib/instagram";

/**
 * Instagram username field — @ prefix overlaid on the left; accepts handle, @handle, or pasted profile URL.
 */
export default function InstagramInput({
  id,
  value,
  onChange,
  className = "",
  placeholder = "mamboloft",
  ...rest
}) {
  function handleChange(e) {
    onChange(instagramHandle(e.target.value));
  }

  return (
    <div
      className={`field-composite relative flex items-center w-full min-h-[44px] rounded-[12px] border border-black/[0.08] bg-white shadow-[0_2px_8px_rgba(0,0,0,0.03)] ${className}`.trim()}
    >
      <span
        className="absolute left-3 top-1/2 -translate-y-1/2 font-ui text-[15px] font-medium text-ink/50 select-none pointer-events-none"
        aria-hidden
      >
        @
      </span>
      <input
        id={id}
        type="text"
        inputMode="text"
        autoComplete="off"
        spellCheck={false}
        autoCapitalize="off"
        autoCorrect="off"
        className="field-leading-icon min-w-0 flex-1 border-0 bg-transparent py-3 pr-3.5 font-ui text-[15px] font-medium text-ink placeholder:text-ink/40 placeholder:font-normal shadow-none focus:outline-none focus:ring-0 focus:shadow-none focus-visible:!outline-none focus-visible:ring-0"
        value={value || ""}
        onChange={handleChange}
        placeholder={placeholder}
        {...rest}
      />
    </div>
  );
}
